export const setDurationMessage = (payload: any) => {
    const { transmitFailed } = payload;
    if(!transmitFailed) {
        return `Duration: ${payload.duration} mins`
    } else return "";
}


// WEBPACK FOOTER //
// ./src/components/TransferTooltip/utils/setDurationMessage.ts